import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IRole } from '@obvious.tech/constellation'

export const Role = defineEntity('Role', {
  endpoint: 'authentication/api/Role',
  schema: SNoop<IRole>(),
})
